import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {StaticPageApiModel} from '../../api/models/static-page.api.model';
import {StaticPageRestService} from '../../api/services/static-page.rest.service';

@Injectable({
  providedIn: 'root'
})
export class StaticPageResolverService implements Resolve<StaticPageApiModel | null> {
  constructor(
    private readonly staticPageRS: StaticPageRestService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<StaticPageApiModel | null> {
    const lookup = (route.data['lookup'] as 'slug' | 'publicSlug' | undefined) || 'publicSlug';
    const identifier = (route.data['slug'] as string) || route.paramMap.get('slug');
    if (!identifier) {
      return of(null);
    }

    const request$ = lookup === 'slug'
      ? this.staticPageRS.getBySlug(identifier)
      : this.staticPageRS.getByPublicSlug(identifier);

    return request$.pipe(
      catchError(() => of(null))
    );
  }
}
